<template>
    <section id = "aboutUs" :key ="id" >
        <article>
            <p v-html="content"></p>
        </article>
    </section>
</template>

<script>
    export default {
        data:()=>{
            return {
                id: '',
                content:'',
                data:{
                    intro:{
                        title:'关于优托邦-优托邦简介',
                        content:"&nbsp;&nbsp;&nbsp;&nbsp;优托邦(UTOPA)是一个拥有全新商业理念的新经济服务平台，以人为核心，探索人与人、人与自然、人与科技的关系，用科技智能手法将实体、线上、虚拟相联结，创建多维度欢乐社交空间。<br/>\n" +
                        "&nbsp;&nbsp;&nbsp;&nbsp;优托邦(UTOPA)创新设计线下线上社交主题，强调丰富体验，满足全方位社交需求。旗下拥有时尚、餐饮、儿童、运动、艺术生活、创新办公等覆盖全方位生活需求的主力品牌，并通过全球品牌客户关系合作网络，实现品牌和项目辐射中国4大区域，6大核心城市，开发管理及运营近250万㎡的商业项目。<br/>\n" +
                        "<br/>\n" +
                        "<strong>>>>>优托邦驿站UTOPA HUB</strong><br/>\n" +
                        "<br/>\n" +
                        "&nbsp;&nbsp;&nbsp;&nbsp;以标准的日常生活配套服务和日常商品消费服务提供为产品设计基础，标准商业面积为3-5万平方米，能满足人对日常生活必需品及生活服务的消费需求，是一个为人带来日常生活服务、餐饮、娱乐、教育等生活及社交体验的标准化产品。（代表项目：广州高志大厦、广州长兴项目、广州科学城项目）<br/>\n" +
                        "<br/>\n" +
                        "<strong>>>>>优托邦时光UTOPA TIMES</strong><br/>\n" +
                        "<br/>\n" +
                        "&nbsp;&nbsp;&nbsp;&nbsp;以提供人对生活、工作、聚会等社交情景体验为基础，标准商业面积在8-10万平方米，根据项目区域环境的个性特色，能满足家庭、商务、生活等日常社交活动的消费需求，是一个为人带来亲子、教育、运动、娱乐、餐饮、购物、生活服务等多方面体验的个性化产品。（代表项目：广州CBD项目）<br/>\n" +
                        "<br/>\n" +
                        "<strong>>>>>优托邦UTOPA</strong><br/>\n" +
                        "<br/>\n" +
                        "&nbsp;&nbsp;&nbsp;&nbsp;以多维的欢乐社交空间为产品设计原型基础，标准商业面积在15万平方米以上的商业项目，以满足“人与自然、人与科技、人与人”与生俱来的需求为产品设计基础，项目本身在区域具有不可复制的天性，能满足不同年龄层人群全方位的生活需求，带来带来亲子、运动、购物、娱乐、教育、家居、餐饮、休闲等商业服务的旗舰型产品。（代表项目：广州奥体项目、株洲神农太阳城）<br/>\n" +
                        "<br/>\n" +
                        "<strong>>>>>优托邦APP</strong><br/>\n" +
                        "<br/>\n" +
                        "&nbsp;&nbsp;&nbsp;&nbsp;优托邦APP是优托邦官方APP，将线上线下功能完美融合，带您体验最前沿的商圈智慧购物与生活方式，给您最便捷的商场购物体验。优托邦APP提供基于优托邦商场的工作生活一站式全方位服务，全面聚合商家各种生活服务，写字楼门禁系统、停车系统、智能wfii系统等为用户打造统一的工作生活服务入口，为客户提供了优托邦商圈内吃、住、行、游、购、娱一站式服务的全新体验。<br/>\n" +
                        "&nbsp;&nbsp;&nbsp;&nbsp;优托邦APP依托国内领先的技术，助力优托邦商户传统实体商户零成本快速转型新零售互联网+店铺，从以商品为中心转型为以服务客户为中心，借助优托邦APP平台，帮助商户快速积累会员和粉丝，通过平台大数据降低成本快速获取新客户，助力商户决胜新零售。为消费者发现最值得信赖的商家，让消费者享受超低折扣的优质服务；为商家找到最合适的消费者，给商家提供最大收益的互联网推广。"
                    },
                    TOS:{
                        title:'关于优托邦-服务条款',
                        content:"<strong>一、总则</strong><br>\n" +
                        "<br>\n" +
                        "\n" +
                        "优托邦与用户共同确认：<br>\n" +
                        "1.1、 用户在使用优托邦服务前，已仔细阅读《优托邦用户协议》（以下简称“本协议”）的全部内容，对于本协议中的加重字体、斜体、下划线、颜色标记等条款已重点阅读、理解。<br>\n" +
                        "1.2、 用户同意本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击\"注册\"按钮即表示用户与优托邦达成以下协议，完全接受本协议项下的全部条款，本协议即在用户与优托邦之间产生法律效力，对双方均具有法律约束力。<br>\n" +
                        "1.3、 用户注册成功后，将获得自行注册的用户账号和自行设定的密码在优托邦的使用权限，该用户帐号和密码由用户负责保管；用户对以其用户帐号进行的所有活动和事件负法律责任。<br>\n" +
                        "1.4、 优托邦用户协议、各个频道单项服务条款、全部活动规则及公告、声明等，均为本协议不可分割的组成部分（以下统称协议）。优托邦有权对协议进行不定期修订、更新。修改后的协议一经公布即有效替代原有协议，新协议公布时会以适当方式通知用户，用户可随时查询最新协议。用户在使用优托邦提供的各项服务之前，应仔细阅读本协议及本协议不可分割的各项内容。用户在使用相关服务时,应关注并遵守其所适用的相关条款。用户如不同意本服务协议及/或对其的修改，可以主动取消或停止使用优托邦提供的服务；用户一旦使用优托邦服务，即视为用户已了解并完全同意本协议及其他服务条款中的各项内容，包括优托邦对本协议及其他服务条款所做的任何修改协议及/或协议的修改将在用户与优托邦之间产生法律效力。<br>\n" +
                        "<br>\n" +
                        "<strong>二、相关定义</strong><br>\n" +
                        "<br>\n" +
                        "2.1、 优托邦：指广州高维网络科技有限公司运营和所有的网络交易服务平台（域名：www.utopa.com）。广州高维网络科技有限公司通过优托邦平台向用户和商户提供相关互联网端及移动端交易服务。<br>\n" +
                        "2.2、 团购： 指商户通过优托邦网平台以优惠价格发布商品或服务售卖信息，用户通过优托邦网平台购买，并凭电子凭证消费的商业活动。<br>\n" +
                        "2.3、 团购信息： 指商户通过优托邦网平台发布的商品或服务售卖信息，包括但不限于商品或服务的团购价格、介绍、使用说明等。团购信息在法律上构成商家就团购商品/服务向用户发出的要约。<br>\n" +
                        "2.4、 用户： 指接受并同意“优托邦用户协议”全部条款，并完成优托邦网平台注册程序，获得可以登陆优托邦网会员系统权限的正式注册会员。<br>\n" +
                        "2.5、 商户： 指通过优托邦平台发布团购信息，向用户提供团购商品或服务的自然人、法人或其他组织。<br>\n" +
                        "2.6、 优托邦券：简称“优托邦券”，指用户通过优托邦平台购买商户的服务或商品并付款后，优托邦平台自动向用户以短信、网页或其他形式发放的，用以兑换实际商品或服务的电子凭证。<br>\n" +
                        "2.7、 优托邦/商户优惠券： 指优托邦/商户通过赠送、市场推广或其他活动向用户提供的可用来抵扣部分团购价款的优惠券，不具有购物凭证的作用。<br>\n" +
                        "<br>\n" +
                        "<strong>三、用户资格及注册</strong><br>\n" +
                        "<br>\n" +
                        "3.1、 用户应为具有完全民事权利能力和民事行为能力的自然人、法人，或是能够独立承担民事责任的其他组织。用户若不具有前述规定的法律能力，须经法定代理人同意或由法定代理人代理，或是得到有权主体授权后进行注册、交易。<br>\n" +
                        "3.2、 用户使用优托邦提供的网络平台服务前，应自行准备如下设备并承担如下开支：<br>\n" +
                        "3.2.1、 自行配备上网的所需设备，包括个人电脑、调制解调器、移动设备或其他必备上网装置；<br>\n" +
                        "3.2.2、 自行负担个人上网所支付的与此服务有关的电话费用、网络费用等。<br>\n" +
                        "3.3、 用户点击“同意以下协议并注册”按钮，则视为用户同意本协议的所有条款，且具有浏览优托邦平台相关信息、提交订单、发表评价等使用优托邦提供的全部服务的权利能力和行为能力，同意承担由此带来的全部法律责任。<br>\n" +
                        "3.4、 用户注册、使用优托邦不得出于非法或破坏优托邦交易秩序的目的，用户保证向优托邦提交的全部信息均为本人真实、准确、有效和完整的信息，不存在盗用、借用、买入非本人手机号码、电子邮箱等进行注册、虚假交易和作弊交易的行为，用户若存在上述违规行为，优托邦有权取消其获奖资格或其因参加活动所获产品或权益，并停止服务、封停帐号且以后也不再向其提供服务。如该违规行为给优托邦造成损失的，优托邦保留追究赔偿及诉至法律解决的权利。<br>\n" +
                        "3.5、 用户注册成功后，应妥善保管其优托邦平台帐户及密码，定期或不定期修改密码，在每次使用优托邦服务完毕后及时退出帐户，以确保帐户安全。用户应对其优托邦注册账号和密码下进行的行为和发生的事件负责。用户不得将优托邦平台帐户出借、转让或用作其他非法用途，否则因帐户未妥善保管而造成损失的，用户应承担相应法律责任，除非有证据证明该行为与用户无关。若用户因优托邦平台帐户被盗或因其他非用户原因造成损失的，用户应立即通知优托邦并向公安机关报案。<br>\n" +
                        "<br>\n" +
                        "<strong>四、用户信息保护</strong><br>\n" +
                        "<br>\n" +
                        "4.1、 优托邦仅在用户注册、提交订单或使用优托邦手机客户端时，基于用户帐户安全、发放优托邦券、定位或配送用户订购、查询的商品或服务、或平台协助保障用户相应权益等需要，收集用户的手机号、电子邮箱、收货地址、当前位置等必要的用户数据，除此之外，优托邦不会收集任何用户信息。用户同意优托邦基于上述目的及范围收集信息。<br>\n" +
                        "4.2、用户同意接收优托邦向用户在平台注册的手机号码、邮箱地址发送商业信息。若用户不再需要这些信息，可通知优托邦取消发送。<br>\n" +
                        "4.3、 优托邦对收集的用户信息中涉及识别用户个人身份和用户个人隐私的信息进行保护，不会将用户的上述信息对外公开或提供给任何第三方，但以下情况除外：<br>\n" +
                        "4.3.1、 用户同意让第三方共享资料；<br>\n" +
                        "4.3.2、 用户同意公开其个人资料，享受为其提供的产品和服务；<br>\n" +
                        "4.3.3、 根据法律法规的规定，或行政机关的要求，向行政机关、司法机关或其他法律规定的第三方披露；<br>\n" +
                        "4.3.4、 为了商品配送或其他为用户利益需要而向交易以外第三方提供的，例如物流配送商、用户同意的商品或服务提供商等。<br>\n" +
                        "4.3.5、 基于保护用户个人隐私的需要，优托邦将按照公示的隐私声明对用户隐私信息进行保护。<br>\n" +
                        "<br>\n" +
                        "<strong>五、优托邦服务</strong><br>\n" +
                        "<br>\n" +
                        "5.1、 用户可根据本协议及优托邦公布的相关使用规则，查阅在优托邦平台上由商户发布的团购产品信息，通过优托邦平台订购具体团购产品，发布产品评价信息，邀请好友，参加优托邦不定期组织的有关活动，及优托邦现有及将来可能提供的其他服务。<br>\n" +
                        "5.2、优托邦为用户和商户达成交易提供第三方交易平台服务，优托邦并非商户和用户之间团购产品或服务交易的相对方。是否与商户达成交易完全取决于用户的选择，优托邦仅为用户和商户达成交易提供居间服务，并不对商户的产品或服务进行任何形式的担保。用户所购产品或服务的实际提供方为平台交易页面公示的经营者，用户购买服务产品后若出现消费纠纷，应第一时间联系商户解决，若需优托邦提供帮助的，可以联系优托邦予以协助，同时，用户应知悉，除法律规定应由优托邦承担的责任外，优托邦不对商户本身的经营行为承担法律责任。<br>\n" +
                        "5.3、优托邦及商户会不定期在优托邦平台组织相关营销活动，用户可选择参加这些营销活动，也可不参加这些营销活动，用户若参加这些营销活动，则应遵守这些营销活动的相关规则。优托邦有权根据市场策略决定活动的形式、内容及适用的用户、每个用户的优惠幅度、购买限制、次数等内容。不符合活动条件的用户无法享受相应的优惠，但可以以非活动价正常购买。<br>\n" +
                        "5.4、优托邦平台会接入第三方服务商（简称TP服务商）的相关服务，第三方服务商提供的产品或服务会在平台上显示此服务由“某某”服务商提供，用户在购买此类第三方服务商提供的产品或服务时，应仔细阅读相关服务约定，遵守相关服务规则。第三方服务商提供的服务或产品，由该第三方负责商户资源的数量和质量，并向用户提供售前、售后等保障服务，用户因购买第三方服务商提供的服务产生消费纠纷的，用户可优先联系该服务商解决，若该第三方服务商无法解决的，用户可要求优托邦予以协助处理，但用户应知晓，优托邦并非服务的提供方，除法律规定的事由外，并不承担由此产生的法律责任。<br>\n" +
                        "5.5、为了保障消费者的权益，优托邦建立了相应的保障机制，比如未消费随便退等。用户在购买某个产品时，若该产品页面标识了相应的服务承诺，则用户可依据该服务规则享受相应的保障服务。但未标识保障服务标识或不符合保障条件的用户，无法获得相应保障。用户购买非优托邦保障的服务或产品产生消费纠纷的，应依照普通处理程序，优先联系相应的商户处理。<br>\n" +
                        "<br>\n" +
                        "<strong>六、用户行为规范</strong><br>\n" +
                        "<br>\n" +
                        "6.1、用户保证在账户注册及下订单时向优托邦提交的信息真实、有效、详尽、准确，能满足优托邦向用户提供服务的需要。若用户信息发生变更的，用户应及时修改相应信息，以保证服务的准确性。若用户提交的信息中有虚假、不准确等内容，导致优托邦无法提供服务的，优托邦有权暂停向该用户提供服务，直至用户提交正确的信息。若因用户提交信息虚假、错误造成损失的，优托邦不承担责任。<br>\n" +
                        "6.2、 用户在使用优托邦提供的前述服务时，应遵守本协议及优托邦的相关使用规则，遵守自愿、平等、公平及诚实信用原则，不利用优托邦平台侵犯他人合法权益及谋取不正当利益，不扰乱网上交易的正常秩序。<br>\n" +
                        "6.3、 用户可以在优托邦平台发布对商品或服务的购买体验、评价等信息，并可对其进行适当的修改、删除，但不得在优托邦平台发布包含以下内容的言论：<br>\n" +
                        "6.3.1、 反对宪法所确定的基本原则，煽动、抗拒、破坏宪法和法律、行政法规实施的；<br>\n" +
                        "6.3.2、 煽动颠覆国家政权，推翻社会主义制度，煽动、分裂国家，破坏国家统一的；\n" +
                        "6.3.3、 损害国家荣誉和利益的；<br>\n" +
                        "6.3.4、 煽动民族仇恨、民族歧视，破坏民族团结的；<br>\n" +
                        "6.3.5、 任何包含对种族、性别、宗教、地域内容等歧视的；<br>\n" +
                        "6.3.6、 捏造或者歪曲事实，散布谣言，扰乱社会秩序的；<br>\n" +
                        "6.3.7、 宣扬封建迷信、邪教、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的；<br>\n" +
                        "6.3.8、 公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的；<br>\n" +
                        "6.3.9、 损害国家机关信誉的；<br>\n" +
                        "6.3.10、 其他违反宪法和法律行政法规的。<br>\n" +
                        "用户在优托邦平台发布的信息，均代表用户的观点，与优托邦无关，用户须对其言论独立承担完全的法律责任。<br>\n" +
                        "6.4、 用户在使用优托邦提供的服务时，不得有下列行为：<br>\n" +
                        "6.4.1、 利用优托邦平台从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；<br>\n" +
                        "6.4.2、 将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，加以上载、发布、发送电子邮件或以其他方式传送；\n" +
                        "6.4.3、 干扰优托邦平台正常运行，非法入侵优托邦服务器、篡改优托邦代码或其他损害优托邦系统的行为；<br>\n" +
                        "6.4.4、 企图规避优托邦平台的安全设置或网络系统，包括获取用户不应获取的数据，登录未经明确授权的服务器或帐户，或采用运行端口扫描等方式窥探其他网络的安全措施；\n" +
                        "6.4.5、 以导致优托邦的计算机系统或设施承受不合理负载的方式获取优托邦提供的服务或网站信息，或进行可能导致此类情况出现的行为；<br>\n" +
                        "6.4.6、 实施任何形式的网络监控，从而截取与自身无关的信息；<br>\n" +
                        "6.4.7、 利用优托邦平台从事与网上购物无关或不是以购物为目的的活动，试图扰乱正常购物秩序，谋取不正当利益的行为；<br>\n" +
                        "6.4.8、通过不正当手段（包括但不限于通过自我邀请、相互邀请、使用虚假手机号、非本人手机号、模拟客户端等）批量注册账户、批量购买产品，从而有碍其他用户公平参与平台活动 ，或获取返利、优惠券等其他经济利益的行为 ；<br>\n" +
                        "6.4.9、 大量购买商品或服务后又大量退货或囤积牟利，损害商户、用户或优托邦利益的行为；<br>\n" +
                        "6.4.10、购买、盗用或通过其他方式获得他人注册账号参与活动或交易的行为。<br>\n" +
                        "6.4.11、 其他损害他人或优托邦合法权益的行为。<br>\n" +
                        "6.5、一经发现用户提供虚假信息或有上述禁止的言论或行为的，优托邦有权采取暂停提供服务、删除违法违规信息、限制用户购买、取消优惠或获得的权益资格、禁止用户发言、冻结用户帐户、冻结相应券码、永久封禁账户等处理措施。若因用户的上述言论或行为给他人或优托邦造成损失的，用户还应承担赔偿责任及其他相关法律责任，包括但不限于行政责任、刑事责任等。<br>\n" +
                        "6.6、 若国家相关机关向优托邦发出命令、指示、裁决等法律文书或第三人向优托邦投诉并提供相关证据材料，要求冻结、关闭用户帐号及交易的，优托邦有权对相关帐号及交易进行冻结或取消，同时对违反本协议及优托邦相关服务规则的用户，优托邦有权封停其帐号。优托邦采取上述措施的，将通过用户注册时提交的联系信息通知用户。<br>\n" +
                        "6.7、 用户应遵守本协议及优托邦公示的各项服务规则的内容，若因用户违反本协议及服务规则造成损失的，用户应予以赔偿。<br>\n" +
                        "6.8、用户发现优托邦平台商户页面内容错误或有其他虚假信息时，可以通过页面的纠错通道进行反馈，也可通过优托邦客服进行反馈，优托邦鼓励用户对不实信息进行举报。对用户反馈的不实信息，优托邦将尽快予以核实。<br>\n" +
                        "6.9、用户使用优托邦提供的服务，发现客户端或网站内容有瑕疵或其他影响用户体验的问题时，可通过优托邦客户端或网站预留的通道向优托邦反馈相关问题或提出相关建议。优托邦收到用户的反馈后会尽快予以核实和解决。<br>\n" +
                        "<br>\n" +
                        "<strong>七、优托邦的权利与义务</strong><br>\n" +
                        "<br>\n" +
                        "7.1、优托邦有权对平台功能进行升级和改造，有权基于服务的稳定对相关服务器进行停机维护，优托邦在行使以上权利时，将尽力不对用户的使用造成影响。若影响用户使用的，优托邦会提前在优托邦客户端或网站予以公告。<br>\n" +
                        "7.2、优托邦有权制定优托邦平台的相关交易规则和服务规则，并有权对这些规则进行修订和更新。优托邦修改上述内容时，会以适当的方式通知用户。<br>\n" +
                        "7.3、优托邦有权记录用户的相关交易行为，有权对用户是否合法进行交易进行监督和检查。若发现用户违反国家相关法律法规规定或优托邦平台相关规则的，优托邦有权采取包括冻结账号、冻结交易、永久封禁、拒绝服务等措施。<br>\n" +
                        "7.4、优托邦有权在优托邦平台开展相关营销活动，这些营销活动优托邦有权以自己认为合适的方式开放给符合条件的不特定用户，且活动的形式、内容、期限、条件等均由优托邦自行决定。这些活动用户可以自行选择参加，也可以不参加，但若用户选择参加，用户应遵守相关活动规则。<br>\n" +
                        "7.5、出于维护正常交易秩序，保证平台全体用户合法权益和公平交易权的目的，优托邦会制定相关的反作弊策略。对购买条件有限制或必须符合条件才可享受优惠的用户或产品，优托邦有权进行监控和抽查，若发现用户违反相关反作弊策略的，优托邦有权取消用户所获优惠，并冻结其账号。同时，优托邦有权根据用户违反本协议的情节严重程度，决定是否永久封停用户账号并拒绝为其提供服务。<br>\n" +
                        "7.6、优托邦应尽力保证服务的稳定性和安全性，在力所能及的情况下，保证用户信息安全，未经用户同意，不得随意泄露用户信息。<br>\n" +
                        "7.7、优托邦应履行其通过客户端或网页向用户做出的服务保障承诺，履行未消费随便退等优托邦在平台明确对用户做出的承诺，但优托邦明示不适用这些承诺的除外。<br>\n" +
                        "<br>\n" +
                        "<strong>八、服务的中断和终止</strong><br>\n" +
                        "<br>\n" +
                        "8.1、 优托邦会尽全力维护平台的正常运行，以向用户提供持续、稳定、安全、顺畅的服务。但用户理解并同意：优托邦对服务页面进行改版、升级网站系统、增加服务功能等须中断服务的操作时，有权暂时中断服务。优托邦将尽可能在实施以上行为时予以提前公告，并尽可能将影响降低到最小。<br>\n" +
                        "8.2、 用户可自行停止使用优托邦提供的服务，并可向优托邦提交申请，要求封停或注销其帐户。用户帐户被封停或注销后，用户将不能使用优托邦平台除浏览页面外的所有服务，但优托邦仍有权保留用户的所有注册信息及过往交易记录，对用户在优托邦平台从事违法行为或违反本协议及相关规定的行为，优托邦仍有权行使本协议规定的权利并追究用户的法律责任。<br>\n" +
                        "8.3、 优托邦可在下列情况下，自行停止向用户提供服务，并封停或注销其帐户，若因用户行为给优托邦造成损失的，用户还应负责赔偿：<br>\n" +
                        "8.3.1、 用户违反本协议相关规定的，不论用户是否直接、间接或者通过他人再次注册成为优托邦用户，优托邦均有权停止向其提供服务；<br>\n" +
                        "8.3.2、 每个用户仅可在优托邦注册一个帐户，若用户注册多个帐户或使用关联帐户购买本站有购买限制的产品或谋取不正当利益的，优托邦有权取消交易并停止向该用户提供服务，用户因此获取的利益须退还；<br>\n" +
                        "8.3.3、若优托邦通过技术检测、人工抽检等手段有合理理由认为用户资料信息为错误、不实、失效或不完整，本网站有权冻结或封禁用户账号及其账号内的所有券码和金额，并拒绝用户现在或将来使用本站网站网络服务的全部或部分。 用户使用虚假信息注册的，包括但不限于使用虚假姓名、虚假地址、虚假手机号、虚假电子邮箱等，优托邦均有权立即停止向其提供服务；<br>\n" +
                        "8.3.4、 本协议终止或更新时，用户明示不同意接受新协议的；<br>\n" +
                        "8.3.5、 其他违反优托邦相关规定或致使优托邦或他人遭受利益损害的行为。<br>\n" +
                        "<br>\n" +
                        "<strong>九、责任限制</strong><br>\n" +
                        "<br>\n" +
                        "9.1、 不论在任何情况下，优托邦对由于互联网正常的设备维护，互联网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，暴乱，骚乱，灾难性天气（如火灾、洪水、风暴等），爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能履行或延迟履行服务不承担责任。<br>\n" +
                        "9.2、如因上述不可抗力或其他优托邦无法控制的原因使优托邦平台的销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，优托邦不承担责任。但优托邦会在最大限度内尽可能合理地协助处理善后事宜，并努力使客户免受经济损失及其他损失。<br>\n" +
                        "9.3、 基于互联网的特殊性，优托邦平台显示的信息可能有一定的滞后性或差错，对此情形用户应知悉并理解；用户须自行辨别真伪，谨慎预防风险。<br>\n" +
                        "<br>\n" +
                        "<strong>十、知识产权</strong><br>\n" +
                        "<br>\n" +
                        "10.1、 用户同意，用户在优托邦平台发表的产品使用体验、产品讨论或图片、视频等所有信息（以下简称“信息”），除署名权、发表权、修改权外的其他知识产权权利（包括但不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），均独家排他无偿许可给优托邦使用 ，并同意优托邦以自己名义就所述权利的保护采取任何形式的法律行为，并获得全部赔偿。 本协议已经构成《著作权法》第二十五条所规定的书面协议，其效力及于用户在优托邦平台发布的任何受著作权法保护的作品内容，无论该内容形成于本协议签订前还是本协议签订后。<br>\n" +
                        "10.2、 优托邦及优托邦许可的关联方有权将用户在优托邦平台发表的产品使用体验、产品讨论或图片进行使用或者与其他人合作使用，使用范围包括但不限于网站、电子杂志、杂志、刊物等。<br>\n" +
                        "10.3、用户不得发布任何侵犯他人著作权、商标权等知识产权或其他合法权利的内容；如果有其他用户或权利人发现用户发布的信息涉嫌知识产权、或其他合法权益争议的，上述用户或权利人要求优托邦删除用户发布的信息，或者采取其他必要措施予以制止的，优托邦将会依法采取必要措施予以处理。<br>\n" +
                        "<br>\n" +
                        "<strong>十一、 通知和公告</strong><br>\n" +
                        "<br>\n" +
                        "11.1、 优托邦向用户发送的所有通告，将通过页面公告、手机短信息、客户端信息推送或电子邮件的方式传送。优托邦的活动信息也将定期或不定期通过上述方式向用户发送。用户协议条款的修改、服务变更、或其它重要事件的通告都会以此形式进行。<br>\n" +
                        "11.2、 用户可以选择接受或不接受优托邦通过上述形式向其发送订单信息、促销活动等信息。用户选择不接受的，可以随时通知优托邦取消发送。<br>\n" +
                        "<br>\n" +
                        "<strong>十二、法律管辖和适用</strong><br>\n" +
                        "<br>\n" +
                        "12.1、 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国大陆地区法律。<br>\n" +
                        "12.2、 如发生本协议条款与上述法律相抵触时，则这些条款将完全按上述法律规定重新解释，但不影响其它合法条款对用户产生的法律效力和影响。<br>\n" +
                        "12.3、 本协议的规定是可分割的，如本协议任何规定被裁定为无效或不可执行，则该规定可被删除，不影响其余条款的继续执行。<br>\n" +
                        "12.4、 如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向广州市天河区人民法院及其上一级人民法院提起诉讼。<br>"
                    },
                    disclaimer:{
                        title: '关于优托邦-免责声明',
                        content: '1、一切移动客户端用户在下载并浏览优托邦APP软件时均被视为已经仔细阅读本条款并完全同意。凡以任何方式登陆优托邦APP，或直接、间接使用优托邦APP资料者，均被视为自愿接受本网站相关声明和用户服务协议的约束。<br/>\n' +
                        '2、优托邦APP转载的内容并不代表优托邦APP之意见及观点，也不意味着本网赞同其观点或证实其内容的真实性。<br/>\n' +
                        "3、优托邦APP转载的文字、图片、音视频等资料均由优托邦APP用户或者商户提供，其真实性、准确性和合法性由信息发布人负责。优托邦APP不提供任何保证，并不承担任何法律责任。<br/>\n" +
                        "4、优托邦APP所转载的文字、图片、音视频等资料，如果侵犯了第三方的知识产权或其他权利，优托邦对此不承担责任。<br/>\n" +
                        "5、优托邦APP不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该外部链接指向的不由优托邦APP实际控制的任何网页上的内容，优托邦APP不承担任何责任。<br/>\n" +
                        "6、用户明确并同意其使用优托邦APP网络服务所存在的风险将完全由其本人承担；因其使用APP手机APP网络服务而产生的一切后果也由其本人承担，优托邦\tAPP对此不承担任何责任。<br/>\n" +
                        "7、除优托邦APP注明之服务条款外，其它因不当使用优托邦APP而导致的任何意外、疏忽、合约毁坏、诽谤、版权或其他知识产权侵犯及其所造成的任何损失，优托邦APP概不负责，亦不承担任何法律责任。<br/>\n" +
                        "8、对于因不可抗力或因黑客攻击、通讯线路中断等优托邦APP不能控制的原因造成的网络服务中断或其他缺陷，导致用户不能正常使用优托邦APP，优托邦APP不承担任何责任，但将尽力减少因此给用户造成的损失或影响。<br/>\n" +
                        "9、本声明未涉及的问题请参见国家有关法律法规，当本声明与国家有关法律法规冲突时，以国家法律法规为准。<br/>\n" +
                        "10、优托邦APP相关声明版权及其修改权、更新权和最终解释权均属优托邦APP所有。"
                    }
                }
            }
        },
        created() {
            this.id = this.$route.params.about;
            this.getData(this.id);
        },
        watch: {
            $route(){
                this.id = this.$route.params.about;
                this.getData(this.id);
            }
        },
        methods:{
            getData (id) {
                    switch (id){
                        case 'intro':
                            document.title = this.data.intro.title;
                            this.content = this.data.intro.content;
                            break
                        case  'TOS':
                            document.title = this.data.TOS.title;
                            this.content = this.data.TOS.content;
                            break
                        case  'disclaimer':
                            document.title = this.data.disclaimer.title;
                            this.content = this.data.disclaimer.content;
                            break
                        default :
                            document.title = '';
                            this.content = '';
                            break
                    }
            },

        }

    }
</script>

<style  lang="scss">
    @import '../../assets/css/px2rem.scss';
    #aboutUs{
        article{
            padding:px2rem(20);
            font-size: px2rem(14);
            line-height: px2rem(20);
            color: #666;
            letter-spacing: 0.5px;
            p{
                text-align: justify;
            }
        }
    }
</style>
